import createInfoBarMessageViewState from './createInfoBarMessageViewState';
import { getRevocationInfo } from './createRevocationInfoBarMessage';
import { getLabelFromStore } from 'owa-mail-protection/lib/utils/clp/getExistingCLPInfo';
import ItemPartViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemPartViewState';
import shouldAppendRevocationInfobar from 'owa-mail-revocation/lib/utils/shouldAppendRevocationInfobar';
import { ClientItem } from 'owa-mail-store';
import {
    InfoBarMessageRank,
    InfoBarMessageViewState,
    InfoBarCustomAction,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function tryCreateCLPLabelInfoBarMessage(
    message: ClientItem,
    key: string,
    viewstate: ItemPartViewState
): InfoBarMessageViewState {
    if (!viewstate.shouldShowCLPLabel) {
        return null;
    }

    const label = getLabelFromStore(message.MSIPLabelGuid);
    if (label) {
        let rank: InfoBarMessageRank = InfoBarMessageRank.Sensitivity;
        let messageParts: (InfoBarCustomAction | string)[] = [label.infobarDisplayText];

        if (label.isEncryptingLabel) {
            rank = InfoBarMessageRank.Encryption;
            if (shouldAppendRevocationInfobar(viewstate?.omeMessageState)) {
                // Append revocation action or success status to infobar.
                messageParts.push(getRevocationInfo(viewstate, message));
            }
        }

        const infoBarMessageViewState: InfoBarMessageViewState = createInfoBarMessageViewState(
            key,
            messageParts,
            rank
        );
        return infoBarMessageViewState;
    }
    return null;
}
